import { z } from "zod";

const EnvSchema = z.object({
  PUBLIC_API_URL: z.url(),
  PUBLIC_APPINSIGHTS_INSTRUMENTATIONKEY: z.string().optional(),
  PUBLIC_APPLICATION_VERSION: z.string(),
  PUBLIC_BUILD_DATE: z.iso.datetime(),
  PUBLIC_CLIENT_ID: z.uuid(),
  PUBLIC_ENVIRONMENT: z.enum(["production", "staging", "local"]),

  PUBLIC_FLUID_RELAY_ENDPOINT: z.url(),
  PUBLIC_FLUID_RELAY_TENANT: z.uuid(),
  PUBLIC_FRONTEND_URL: z.url(),

  PUBLIC_INSTALLATION_VERSION: z.string(),
  PUBLIC_PORTAL_URL: z.url(),
  PUBLIC_SCOPE: z.string(),

  PUBLIC_VIDEO_INTRO_ID: z.string().optional(),
});

export const env = EnvSchema.parse({
  PUBLIC_API_URL: import.meta.env.PUBLIC_API_URL,
  PUBLIC_APPINSIGHTS_INSTRUMENTATIONKEY: import.meta.env
    .PUBLIC_APPINSIGHTS_INSTRUMENTATIONKEY,
  PUBLIC_APPLICATION_VERSION: import.meta.env.PUBLIC_APPLICATION_VERSION,
  PUBLIC_BUILD_DATE: import.meta.env.PUBLIC_BUILD_DATE,
  PUBLIC_CLIENT_ID: import.meta.env.PUBLIC_CLIENT_ID,
  PUBLIC_ENVIRONMENT: import.meta.env.PUBLIC_ENVIRONMENT,

  PUBLIC_FLUID_RELAY_ENDPOINT: import.meta.env.PUBLIC_FLUID_RELAY_ENDPOINT,
  PUBLIC_FLUID_RELAY_TENANT: import.meta.env.PUBLIC_FLUID_RELAY_TENANT,
  PUBLIC_FRONTEND_URL: import.meta.env.PUBLIC_FRONTEND_URL,

  // Versioning
  PUBLIC_INSTALLATION_VERSION: import.meta.env.PUBLIC_INSTALLATION_VERSION,
  PUBLIC_PORTAL_URL: import.meta.env.PUBLIC_PORTAL_URL,
  PUBLIC_SCOPE: import.meta.env.PUBLIC_SCOPE,

  PUBLIC_VIDEO_INTRO_ID: import.meta.env.PUBLIC_VIDEO_INTRO_ID,
});
